<!--
基础用法
 <EditContainer ref='EditContainer' :haveOutRole='false'></EditContainer>
	this.$refs.EditContainer.save()  // 此方法将返回所有该页面的数据
数据格式
	{
		nameList:[{
			language:'zh',
			name:'我是商家名称'
		}],
		org:{
			areaId:1  //区域id
			businessType: '1,2' //模块
			type:'1' 类型 1：企业 2：个人
		}
	}
	注意点
		：haveOutRole  只有在商家列表才需要使用（朱玲使用时不需要填写）不填写或者为true会出现外部关联角色下拉框
		暂时不支持修改编辑状态 只支持添加状态
		save() 方法返回值返回需要的参数 不建议再组件内实现保存等功能
-->
<template>
<div :class='classWidth'>
	<p class="mr1x_E curP_E taL cSub">{{getLanguageStr("word1645","商家类型")}}：</p>
	<p class="mr1x_E curP_E taL">
		<MyRadio
			class="dpIB mr2x"
			name="typesq"
			v-model="requestData.org.type"
			label="1"
		>{{getLanguageStr("word1713","企业商家")}}</MyRadio>
		<MyRadio
			class="dpIB"
			name="typesq"
			v-model="requestData.org.type"
			label="2"
		>{{getLanguageStr("word1714","个人商家")}}</MyRadio>
	</p>
	<div class="tableSys pb1x mt1x">
		<div>
			<p class='cSub'>
				<span class="cWarning">*</span>{{getLanguageStr("word1963","商家名称")}}：
			</p>
			<EditInputExtend
				v-for="(item,index) in requestData.nameList"
				:key="item.idKey"
				@AddName="AddName"
				@ReduceName="ReduceName"
				@changeLangs="changeLangs"
				:selectActive='item.selectActive'
				:value='item.name'
				:placeKey="index"
				:isAdd="index===0?true:false"
				@ValueChange='ValueChange'
			></EditInputExtend>
		</div>
		<div class="w4x"></div>
		<div class="w30pct">
			<p class='cSub'><span class="cWarning">* </span>{{getLanguageStr("word1653","商家地区")}}：</p>
			<div>
				<my-select
					ref="earaSelect"
					class="w100pct sizeM"
					verification = 'notEmpty'
					@Click="selectCountry"
					:bindActive="requestData.org.areaId"
					:list="areas"
				></my-select>
			</div>
		</div>
	</div>
	<div v-if='this.haveOutRole' class="tableSys pb1x">
		<div>
			<p class='cSub'><span class="cWarning">*</span>{{getLanguageStr('word1657','授权外部角色')}}：</p>
			<div><my-select ref="roleSelect" class='w36x sizeM' :list="entityRoles" @Click="selectRole" :bindActive="requestData.RolesId" ></my-select></div>
		</div>
		<div></div>
	</div>
	<div class="cSub">{{$t('word75',['类型'])}}: </div>
	<div class="mt1x mr2x_E">
		<MyRadio v-for="type in getTypeText('','serviceType',true)" :key="type.id[0]" v-model="requestData.org.category" :label="type.value" name="serviceType">{{type.name}}</MyRadio>
	</div>
  <!-- 
	<div>
		<div class='cSub'>
			<span class="cWarning">*</span>{{getLanguageStr('phrase693','选择业务板块')}}：
			<Help :code="'register'" :btnClose="false"></Help>
		</div>
		<div class="cb w15x_E fL_E mr2x_E mt2x_E pd1x_E tra-fast_E">
			<div class="panel bgPanel curP">
				<p class="fs14x pr1x">{{getLanguageStr('word1809','运维板块')}}</p>
				<p class="content">{{getLanguageStr('phrase691','适用于安装商、运维商')}}</p>
				<checkbox v-model="yun" class="mr05x" :checkObj='{value:1}' @Click='checked'></checkbox>
			</div>
			<div class="panel bgPanel curP">
				<p class="fs14x pr1x">{{getLanguageStr('word1810','设备板块')}}</p>
				<p class="content">{{getLanguageStr('phrase748','适用于设备商、设备分销商')}}</p>
				<checkbox v-model="she" class="mr05x" :checkObj='{value:2}'  @Click='checked'></checkbox>
			</div>
		</div>
		<div class="errorTip tra-fast" v-show="errorTip.moudle">{{errorTip.moudle}}</div>
	</div>
   -->
</div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import MySelect from '@/components/common/ui/Select'
import InputText from '@/components/common/ui/InputText'
import Loading from '@/components/common/ui/Loading'
import VTree from '@/components/common/ui/vTree/Tree'
import Window from '@/components/common/ui/WindowForNew'
import Checkbox from '@/components/common/ui/Checkbox'
import Help from '@/components/common/Help.vue'
import MyRadio from '@/components/common/ui/Radio'
import EditInputExtend from './EditInputExtend'
import * as lib from '@/util/lib'
import {getLanguageStr, getLanguageType} from '@/util/language'
import StatusIco from '@/components/common/ui/StatusIco'
import { searchAreaList } from '@/api/base.js'
import { entityRelsAll } from '@/api/manage/user.js'
import {getOutRoles} from '@/api/manage/roleFunc.js'
import {apiGetCountry} from '@/api/base.js'
export default {
  name: 'editContainer',
  computed: {
    ...mapGetters({
      countries: 'region/countries'
    })
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    haveOutRole: {
      type: Boolean,
      default: true
    },
    propDataOption: {
      type: Object,
      default: null
    },
    haschoosed: {
    },
    classWidth: {
      type: String,
      default: ''
    }
  },
  components: {
    MySelect,
    InputText,
    Loading,
    VTree,
    Window,
    Checkbox,
    StatusIco,
    EditInputExtend,
    Help,
    MyRadio
  },
  data () {
    return {
      type: 1,
      types: '1',
      yun: false,
      she: false,
      // nameArr: [{'selectActive': 1, language:stage.languageId, name: '', idKey: this.getUUID()}],
      areas: [],
      entityRoles: [],
      allLangs: stage.languageList,
      haveSchoosedLangs: [1],
      allLansId: [],
      businessType: [],
      requestData:{
        org:{
          // adminId:this.userInfo.userInfo.id,
			category:lib.getTypeText("","serviceType",true)[0].value,//默认取第一个值
          type: '1', // 1 企业   2个体
          areaId: '', // 商家地区
          // businessType: '',
          timezone: ''// 时区code
        },
        nameList: [{'selectActive': stage.languageList[0].value, language: stage.languageList[0].value, name: '', idKey: this.getUUID()}],
        RolesId: undefined // 对方外部角色
      },
      errorTip: {
        moudle: ''
	  }
    }
  },
  watch: {
    requestData: {
      handler (val) {
        this.$emit('updateData', this.requestData);
      },
      deep: true
    },
    propDataOption (v) {
      if (v) {
        v.org.type = v.org.type.toString()
        if (v.org.businessType.indexOf(1) !== -1) {
          this.yun = true
        } else {
          this.yun = false
        }
        if (v.org.businessType.indexOf(2) !== -1) {
          this.she = true
        } else {
          this.she = false
        }
        if (v.nameList.length === 0) {
          v.nameList = [{'selectActive': stage.languageList[0].value, language: stage.languageList[0].value, name: '', idKey: this.getUUID()}]
        } else {
          v.nameList.map(item => {
            item.idKey = this.getUUID()
          })
        }
        if (v.org.businessType === '') {
          this.businessType = []
        } else {
          let businessType = v.org.businessType.split(',')
          this.businessType = businessType
        }
        this.requestData = _.cloneDeep(v);
      }
    }
  },
  methods: {
    ...mapActions({
      GetAllCountries: 'region/GetAllCountries'
    }),
    getLanguageStr,
    searchAreaList,
    getTypeText: lib.getTypeText,
    reset () {
    	this.errorTip = {
        moudle: ''
	  	}
    },
    checked (check, index, checkObj) {
      this.reset()
      if (check) {
        this.businessType.push(checkObj.value)

        if (checkObj.value === 1) this.yun = true
        if (checkObj.value === 2) this.she = true
      } else {
        // console.log(this.businessType)
        // console.log(this.businessType.indexOf(checkObj.value))
        let bus = this.businessType.slice(0)
        bus.splice(bus.indexOf(checkObj.value), 1)
        if (bus.length === 0) {
          if (checkObj.value === 1) {
            this.$nextTick(() => {
              this.yun = true
            })
          }
          if (checkObj.value === 2) {
            this.$nextTick(() => {
              this.she = true
            })
          }
          this.errorTip.moudle = getLanguageStr('phrase698', '至少选择1个业务板块')
          return
        }
        this.businessType.splice(this.businessType.indexOf(checkObj.value.toString()), 1)
        if (checkObj.value === 1) this.yun = false
        if (checkObj.value === 2) this.she = false
      }
      // console.log(this.businessType.indexOf(checkObj.value))
      this.requestData.org.businessType = this.businessType.toString()
      this.isNameAll()
    },
    selectRole (index) {
      this.requestData.RolesId = this.entityRoles[index].value
    },
    _getRoleList () {
      this.entityRoles = []
      let request = {
        applyScope: 2, // 1:用户 2:商家
        pageNum: 1,
        pageSize: 50,
        modules: 2 // 1:内部 2：外部
      }
      getOutRoles(request).then(res => {
        if (res.total > 0) {
          this.entityRoles = res.roleList.map(el => ({
            value: el.roleId,
            text: this.getTypeText(el.roleId,'roleType-outer')?this.getTypeText(el.roleId,'roleType-outer'):el.roleName
          }))
          this.entityRoles.unshift({text: getLanguageStr('word66', '-请选择-'), value: 0,token:true})
        } else {
          this.entityRoles = []
        }
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    getUUID () {
      let S4 = this.s4
      let uuid = S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4()
      return uuid
    },
    s4 () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    ValueChange (v, ind) {
      this.requestData.nameList[ind].name = v
      this.requestData.nameList = this.requestData.nameList.slice(0)
      this.$nextTick(() => {
        this.isNameAll()
      })
    },
    changeLangs (code, placeKey, oldValue) {
      this.haveSchoosedLangs.splice(this.haveSchoosedLangs.indexOf(oldValue), 1)
      if (this.haveSchoosedLangs.indexOf(code) !== -1) {
        this.$notify(getLanguageStr('phrase690', '不要重复选择一种语言'))
        this.$nextTick(() => {
          let noUse = this.getNoUse() // 未使用的获取
          this.requestData.nameList[placeKey].selectActive = noUse[0]
          this.requestData.nameList[placeKey].language = noUse[0]
          this.requestData.nameList[placeKey].idKey = this.getUUID()
          this.haveSchoosedLangs.push(noUse[0])
        })
      } else {
        this.requestData.nameList[placeKey].selectActive = code
        this.requestData.nameList[placeKey].language = code
        this.requestData.nameList[placeKey].idKey = this.getUUID()
        this.haveSchoosedLangs.push(code)
      }
    },
    getAllCountries () {
      this.GetAllCountries({
        level: 1
      }).then(() => {
        lib.getIpToDo((ip) => {
          if (ip) {
            apiGetCountry(ip).then(data => {
              if (this.countries.length) {
              // this.requestData.org.areaId = this.countries[0].id
                this.areas = this.countries.map(el => {
                  if (el.code.toLowerCase() === data.toLowerCase() && !this.requestData.org.areaId) {
                    this.requestData.org.areaId = el.id// this.countries[0].id
                    this.requestData.org.timezone = el.defaultTimezone
                  }
                  return {
                    text: el.name,
                    value: el.id,
                    level: el.level,
                    totalLeval: el.totalLevel,
                    code: el.code,
                    timezone: el.defaultTimezone
                  }
                })
                if (!this.requestData.org.areaId) {
                  this.requestData.org.areaId = this.countries[0].id
                  // console.log(this.requestData.org.areaId)
                  this.requestData.org.timezone = this.countries[0].defaultTimezone
                }
              // this.areas.unshift({text: getLanguageStr('word675', '国家'), value: '', def: getLanguageStr('word675', '国家')})
              }
            // console.log(this.requestData.org.areaId)
            }, err => {
              console.log(err)
            })
          } else {
            if (this.countries.length) {
              // this.requestData.org.areaId = this.countries[0].id
              this.areas = this.countries.map(el => {
                if (el.code.toLowerCase() === stage.languageId.toLowerCase() && !this.requestData.org.areaId) {
                  this.requestData.org.areaId = el.id// this.countries[0].id
                  this.requestData.org.timezone = el.defaultTimezone
                }
                return {
                  text: el.name,
                  value: el.id,
                  level: el.level,
                  totalLeval: el.totalLevel,
                  code: el.code,
                  timezone: el.defaultTimezone
                }
              })
              if (!this.requestData.org.areaId) {
                this.requestData.org.areaId = this.countries[0].id
                // console.log(this.requestData.org.areaId)
                this.requestData.org.timezone = this.countries[0].defaultTimezone
              }
              // this.areas.unshift({text: getLanguageStr('word675', '国家'), value: '', def: getLanguageStr('word675', '国家')})
            }
          }
        })
      }).catch(error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    show () {
      lib.windowCtrl($('#addMember'), 'true')
    },
    hide () {
      lib.windowCtrl($('#editMember'), 'false')
    },
    selectCountry (index) {
      this.requestData.org.areaId = this.areas[index].value
      this.requestData.org.timezone = this.areas[index].timezone
    },
    AddName () {
      if (this.requestData.nameList.length + 1 > stage.languageList.length) {
        this.$notify(
          getLanguageStr('phrase685', '已超过语言选择上限')
        )
        return false
      }
      this.$emit('Validate', false)
      let noUse = this.getNoUse() // 未使用的获取
      this.haveSchoosedLangs.push(noUse[0])
      this.requestData.nameList.push({'selectActive': noUse[0], language: noUse[0], name: '', idKey: this.getUUID()})
    },
    ReduceName (indexKey, value) {
      let nameArr = this.requestData.nameList.filter((item, index) => {
        return item
      })
      nameArr.splice(indexKey, 1)
      // this.requestData.nameList = []
      this.requestData.nameList = nameArr

      this.haveSchoosedLangs.splice(this.haveSchoosedLangs.indexOf(value), 1)
      this.isNameAll()
    },
    save () {
      // let dataOption = {
      // 	org: {
      // 		areaId: this.cityValue.value,
      // 		businessType: this.requestData.businessType.toString(),
      // 		type: this.requestData.org.types
      // 	},
      // 	nameList: this.requestData.nameList
      // }
      return this.requestData

      // console.log(this.requestData.nameList)
      // console.log(this.types)
      // console.log(this.cityValue)
    },
    getNoUse () { // 未使用获取
      let noUse = this.allLansId.filter((item, index) => {
        if (this.haveSchoosedLangs.indexOf(item) < 0) return item
      })
      return noUse
    },
    isNameAll () { // 判断所有国家是否都有名字
      let namelist = this.requestData.nameList
      let v = true
      for (let i in namelist) {
        if (namelist[i].name.trim() === '') {
          v = false
        }
      }
      // if (this.businessType.length === 0) {
      //   v = false
      // }
      this.$emit('Validate', v);
    },
    doVerification () {
      let namelist = this.requestData.nameList
      let v = true
      for (let i in namelist) {
        if (namelist[i].name.trim() === '') {
          v = false
        }
      }
      if (this.businessType.length === 0) {
        v = false
      }
      return v
    }
  },
  mounted () {
    let allLansId = this.allLangs.map((item, index) => {
      return item.value
    })
    this.allLansId = allLansId
    if (this.haschoosed) {
      this.haveSchoosedLangs = this.haschoosed
    } else { // 在添加的时候选择系统默认的语言为第一个语言
      allLansId.map(item => {
        if (item == stage.languageId) {
          this.haveSchoosedLangs = [item]
          this.requestData.nameList[0] = {'selectActive': item, language: item, name: '', idKey: this.getUUID()}
        }
      })
    }

    if (this.haveOutRole) {
      this._getRoleList()
    }
    // 初始化所有的国家
    this.getAllCountries()
    // searchAreaList(0).then(data => {
    // 	this.areas = data.map(datas => {
    // 		return { text: datas.name, value: datas.id }
    // 	})
    // 	this.cityValue = this.areas[0]
    // })
    this.isNameAll()
    // 判断是否需要外部角色
    if (this.haveOutRole) {
      // entityRelsAll().then(data => {
      // 	console.log(data)
      // })
    }
  }

}
</script>
<style lang="scss" scoped>
.tableSys .panel:hover{
	box-shadow: 0 0.2em 0.6em rgba(0, 0, 0, 0.16);
}
.content{height:4em;line-height: 1.4em;overflow:hidden;}
.errorTip{opacity:1}
</style>



// WEBPACK FOOTER //
// src/view/manage/provider/components/EditContainer.vue